import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  snackbarStyleViaNestedContent: {
    backgroundColor: "#4caf50",
    color: "white"
  },
  snackbarStyleViaNestedContentError: {
    backgroundColor: "#f44336",
    color: "white",
    justifyContent: "space-evenly"
  },
  snackContent: {
    display: "flex",
    width: "190px",
    fontSize: "16px",
    alignItems: "center"
  },
  iconContent: {
    marginRight: "10px",
    display: "flex"
  }
}));

export default styles;
